import logo from "./logo.png";
import "./App.css";
import Dictionary from "./Dictionary";
export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header">
          <img src={logo} className="main-logo" alt="logo" />{" "}
          <h1>Dictionary App</h1>
        </header>
        <main>
          <Dictionary />
        </main>
        <footer className="App-footer">
          Coded by Tanya Furst and hosted on{" "}
          <a href="https://github.com/furstcontact/dictionary-project">
            GitHub
          </a>
        </footer>
      </div>
    </div>
  );
}
